import { forwardRef } from 'react';

import { Container } from '../Container';
import type { SidebarLayoutProps } from './SidebarLayout.types';

export const SidebarLayout = forwardRef<HTMLDivElement, SidebarLayoutProps>((props, ref) => {
  const { children, component = 'div', sidebarContent, ...otherProps } = props;

  return (
    <Container component={component} maxWidth="xl" {...otherProps} ref={ref}>
      {sidebarContent}
      {children}
    </Container>
  );
});

SidebarLayout.displayName = 'SidebarLayout';
